import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203d9c61"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-white border-gray-300 text-gray-800 dark:border-dark-400 dark:bg-dark-800 dark:text-dark-text-dark",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = { class: "w-full px-6 pt-3" }
const _hoisted_3 = { class: "ml-1 mb-1 flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-1" }, "code", -1))
const _hoisted_5 = { class: "my-auto" }
const _hoisted_6 = {
  key: 0,
  class: "mx-6 mt-3"
}
const _hoisted_7 = { class: "ml-1 mb-1 flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-1" }, "warning", -1))
const _hoisted_9 = { class: "my-auto" }
const _hoisted_10 = {
  class: "border flex px-3 py-3 text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900",
  style: {"user-select":"contain","border-radius":"0.5rem"}
}
const _hoisted_11 = {
  key: 0,
  class: "w-full"
}
const _hoisted_12 = {
  key: 1,
  class: "w-full"
}
const _hoisted_13 = { class: "w-full px-6 pt-6 pb-6" }
const _hoisted_14 = { class: "ml-1 mb-1 flex" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-1" }, "edit_square", -1))
const _hoisted_16 = { class: "my-auto" }
const _hoisted_17 = { class: "flex items-center justify-center" }
const _hoisted_18 = { class: "text-center flex-grow mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewEditor = _resolveComponent("ReviewEditor")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.sourceCode')) + " :", 1)
      ]),
      _createVNode(_component_ReviewEditor, {
        height: 200,
        isEditable: false,
        value: _ctx.entry.sourceCode
      }, null, 8, ["value"])
    ]),
    (_ctx.entry.compileError !== '' || _ctx.entry.runtimeError !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('message.error')) + " :", 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.entry.compileError !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.entry.compileError), 1))
              : _createCommentVNode("", true),
            (_ctx.entry.runtimeError !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.entry.runtimeError), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('message.reviewEditor')) + " :", 1)
      ]),
      _createVNode(_component_ReviewEditor, {
        height: 200,
        isEditable: true,
        onChange: _ctx.setReview,
        value: _ctx.postReviewPresenter.reviewList.value[_ctx.entry.entryId] ?? ''
      }, null, 8, ["onChange", "value"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_IconTextButton, {
          border_radius: 2,
          font_weight: '700',
          icon: 'send',
          iconSize: 'text-2xl',
          padding_bottom: 4,
          padding_left: 12,
          padding_right: 12,
          padding_top: 4,
          text: _ctx.$t(`message.newReviewSubmit`),
          textSize: 'text-base',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickPostReview()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}